<template>
  <a-modal
    v-model="visible"
    :title="
      `${formType === 'add' ? $t('configModel_btn_add_group') : $t('configModel_btn_edit_group')}`
    "
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    centered
  >
    <a-form-model :model="form" :rules="formRules" ref="formElement">
      <!-- 名称 -->
      <a-form-model-item :label="$t('configModel_table_group_name')" prop="groupName">
        <a-input
          v-model="form.groupName"
          :placeholder="$t('configModel_form_group_name_placeholder2')"
          allowClear
          @input="formInput"
          ref="nameForm"
        />
      </a-form-model-item>

      <!-- 描述 -->
      <a-form-model-item :label="$t('com_form_description')" prop="description" style="margin:0">
        <a-textarea
          v-model="form.description"
          :placeholder="$t('com_form_description_placeholder')"
          :rows="6"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/config';

export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      groupInfo: null,
      // 新增
      visible: false,
      formRules: {
        groupName: [
          {
            required: true,
            message: this.$t('configModel_form_group_name_placeholder2'),
            trigger: 'change',
          },
        ],
      },
      // 搜索
      form: {
        groupName: undefined,
        description: undefined,
      },
      formError: '',
      formType: '',
      formLoading: false,
    };
  },
  methods: {
    // 更新列表
    updateList() {
      // 更新列表
      this.callback();
    },

    // 显示
    show(type, record) {
      this.visible = true;
      this.formType = type;

      // focus name
      this.$nextTick(() => {
        this.$refs.nameForm && this.$refs.nameForm.focus();
        this.formReset();

        if (record) {
          console.log('record', record);
          this.groupInfo = record;
          this.form = {
            groupId: record.groupId,
            groupName: record.groupName,
            description: record.description,
          };
        }
      });
    },
    // 提交
    formSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;

          if (this.formType === 'add') {
            API.ConfigGroupSave(this.form)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_add_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            API.ConfigGroupEdit(this.form)
              .then(res => {
                if (res.code === 0) {
                  // this.$message.success(this.$t('com_msg_edit_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // error reset
    formInput() {
      this.formError = '';
    },
    // add form reset
    formReset() {
      this.$refs.formElement.resetFields();
      this.form = {
        groupName: undefined,
        description: undefined,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
